




import { createSlice } from '@reduxjs/toolkit'

export const iconMapSlice = createSlice({
    name: 'iconMap',
    initialState: {
        value: '',
    },
    reducers: {
        setIconMap: (state, action) => {
            state.value = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { setIconMap } = iconMapSlice.actions

export default iconMapSlice.reducer